<template>
    <div class="row clearfix">
        <div v-if="loading" class="loading"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="">
                <div class="header">
                    <h2>История заказов</h2>
                </div>
                <div class="body table-responsive">
                    <table class="table table-bordered table-striped js-table dataTable order-table">
                        <thead>
                        <tr>
                            <th>ID</th>
                            <th>Номер заказа</th>
                            <th>Имя компании</th>
                            <th>Время заказа</th>
                            <th>Цена</th>
                            <th>Опции</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item) in items">
                            <td>{{ item.id }}</td>
                            <td>{{ item.order_number}}</td>
                            <td>{{ item.company }}</td>
                            <td>{{ item.created_at }}</td>
                            <td>{{ item.total_price }} тг</td>
                            <td>
                                <router-link class="btn btn-primary" :to="'/managers/histories/edit/' + item.order_number">Изменить</router-link>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ManagerHistoryAll",

        data() {
            return {
                items: [],
                loading: false,
            }
        },

        mounted() {
            this.loading = true
                this.axios
                    .get(this.axios.defaults.baseURL + 'manager/histories')
                    .then(response => {
                        this.items = response.data.histories;
                    })
                    .catch(error => {
                        console.log(error);
                    }).finally(() => {
                        this.loading = false
                })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/manager/histories/AllUsers.vue